module.exports = new __parcel__URL__("light.217157f5.svg").toString();